import { Box, Typography, Slider, TextField } from "@mui/material";
import { colorPrimary } from "../../../theme";

interface PrecoFilterCardProps {
  min: number;
  max: number;
  value: [number, number];
  onChange: (value: [number, number]) => void;
}
export function PrecoFilterCard({
  min,
  max,
  value,
  onChange,
}: PrecoFilterCardProps) {
  const handleSliderChange = (_: Event, newValue: number | number[]) => {
    onChange(newValue as [number, number]);
  };

  const formatCurrency = (val: number) =>
    val.toLocaleString("pt-BR", {
      style: "currency",
      currency: "BRL",
      minimumFractionDigits: 2,
    });

  return (
    <Box
      sx={{
        bgcolor: "background.paper",
        p: 2,
        borderRadius: 3,
        boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
        border: "1px solid",
        borderColor: "divider",
      }}
    >
      {/* Título */}
      <Box mb={2}>
        <Typography
          fontWeight={700}
          fontSize="0.7rem"
          letterSpacing={1.5}
          textTransform="uppercase"
          color="text.secondary"
        >
          Preço
        </Typography>

        <Box
          sx={{
            width: 32,
            height: 4,
            bgcolor: "primary.main",
            mt: 0.5,
            borderRadius: 2,
          }}
        />
      </Box>

      {/* Conteúdo */}
      <Box display="flex" flexDirection="column" gap={2} px={1}>
        {/* Slider */}
        <Slider
          value={value}
          min={min}
          max={max}
          onChange={handleSliderChange}
          valueLabelDisplay="off"
        />

        {/* Inputs */}
        <Box display="flex" gap={2}>
          <TextField
            fullWidth
            size="small"
            label="DE"
            value={formatCurrency(value[0])}
            InputProps={{ readOnly: true }}
             sx={{
                borderRadius: 3,
                bgcolor: "white",

                "& .MuiOutlinedInput-notchedOutline": {
                borderRadius: 3,
                boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
                border: "1px solid",
                borderColor: "divider",
                },

                "&:hover .MuiOutlinedInput-notchedOutline": {
                    borderColor: colorPrimary,
                },

                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                    borderColor: colorPrimary,
                    borderWidth: "2px",
                },
                }}
          />

          <TextField
            fullWidth
            size="small"
            label="ATÉ"
            value={formatCurrency(value[1])}
            InputProps={{ readOnly: true }}
             sx={{
                borderRadius: 3,
                bgcolor: "white",

                "& .MuiOutlinedInput-notchedOutline": {
                borderRadius: 3,
                boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
                border: "1px solid",
                borderColor: "divider",
                },

                "&:hover .MuiOutlinedInput-notchedOutline": {
                    borderColor: colorPrimary,
                },

                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                    borderColor: colorPrimary,
                    borderWidth: "2px",
                },
                }}
          />
        </Box>
      </Box>
    </Box>
  );
}
